import { render, staticRenderFns } from "./FilesizeColumnRenderer.vue?vue&type=template&id=6c152b8e&"
import script from "./FilesizeColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./FilesizeColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports